import copyMailListRows from '../../helpers/copyMailListRows';
import deleteMailListRows from '../../deleteMailListRows';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { default as getMoveKind } from './getMoveKind';
import folderStore from 'owa-folders';
import { userMailInteractionAction } from 'owa-mail-actions';
import { lazyAddFolderIdToMoveToMruList } from 'owa-mail-move-mru';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { select } from 'satcheljs/lib/legacy';
import handleBlockActionForShadowMailbox from '../../helpers/handleBlockActionForShadowMailbox';
import * as undoActions from 'owa-mail-undo';
/**
 * Move rows from table action
 * @param rowKeys - the row keys of the rows that need to be moved
 * @param destinationFolderId - the folder they need to go to
 * @param originalTableView - the table view the rows are moving from
 */
export default select({
    sourceFolder: function (rowKeys, destinationFolderId, originalTableView) {
        return folderStore.folderTable.get(originalTableView.tableQuery.folderId);
    },
    destinationFolder: function (rowKeys, destinationFolderId, originalTableView) { return folderStore.folderTable.get(destinationFolderId); },
    isUserShadowMailbox: function () { return getUserConfiguration().SessionSettings.IsShadowMailbox; },
})(function moveMailListRowsHelper(rowKeys, destinationFolderId, originalTableView, moveRowsInternal, actionSource, state) {
    var sourceFolder = state.sourceFolder, destinationFolder = state.destinationFolder, isUserShadowMailbox = state.isUserShadowMailbox;
    var moveKind = getMoveKind(isUserShadowMailbox, sourceFolder, destinationFolder);
    var sourceFolderId = originalTableView.tableQuery.folderId;
    if (handleBlockActionForShadowMailbox(sourceFolderId, destinationFolderId)) {
        return;
    }
    undoActions.clearLastUndoableAction();
    // Since row may have been deleted because moveRows is an lazy action,
    // we need to validate the row keys again before performing move
    // Here we cannot compare destinationFolderId with sourceFolderId, because sourceFolderId is null in Search,
    // so we need to get the actual parentFolderId of each row
    var filteredRowKeys = rowKeys.filter(function (rowKey) {
        return originalTableView.rowKeys.indexOf(rowKey) >= 0 &&
            destinationFolderId !=
                MailRowDataPropertyGetter.getParentFolderId(rowKey, originalTableView);
    });
    var instrumentationContexts = [];
    var isSearch = originalTableView.tableQuery.type == 1 /* Search */;
    if (isSearch) {
        filteredRowKeys.forEach(function (rowKey) {
            var instrumentationContext = MailRowDataPropertyGetter.getInstrumentationContext(rowKey, originalTableView);
            if (instrumentationContext) {
                instrumentationContexts.push(instrumentationContext);
            }
        });
    }
    // We do not have any conversations that can be moved
    if (filteredRowKeys.length == 0) {
        return;
    }
    var promiseToReturn;
    switch (moveKind) {
        case 2 /* ShadowMailbox_Delete */:
            // if we are in a ShadowMailbox and actually need to perform a delete,
            // we call the deleteConversations action directly, which handles its own
            // service and undo operation
            return deleteMailListRows(filteredRowKeys, originalTableView.id, false);
        case 1 /* ShadowMailbox_Copy */:
            promiseToReturn = copyMailListRows(filteredRowKeys, originalTableView, destinationFolderId, sourceFolderId);
            break;
        case 0 /* Normal */:
        default:
            // Update Move to mru list
            lazyAddFolderIdToMoveToMruList.importAndExecute(destinationFolderId);
            // Make service request
            // Task 658: Reload client state when move conversation fails on the server.
            promiseToReturn = moveRowsInternal(filteredRowKeys, destinationFolderId, originalTableView, sourceFolderId, actionSource);
            break;
    }
    userMailInteractionAction('Move', instrumentationContexts);
    return promiseToReturn;
});
//# sourceMappingURL=moveMailListRowsHelper.js.map